/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisteredDeviceResponse
 */
export interface RegisteredDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof RegisteredDeviceResponse
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisteredDeviceResponse
     */
    registeredDevices?: number;
}

export function RegisteredDeviceResponseFromJSON(json: any): RegisteredDeviceResponse {
    return RegisteredDeviceResponseFromJSONTyped(json, false);
}

export function RegisteredDeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisteredDeviceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'registeredDevices': !exists(json, 'registeredDevices') ? undefined : json['registeredDevices'],
    };
}

export function RegisteredDeviceResponseToJSON(value?: RegisteredDeviceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'registeredDevices': value.registeredDevices,
    };
}

